module.exports = {"id":"194229","name":"Hugo Mallo","rating":"80","photo":"./data/images/photos/0/194229.png","club":{"name":"Celta Vigo","logo":"./data/images/clubs/CeltaVigo.png"},"positions":["DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HugoMallo0.json
// module id = 1756
// module chunks = 0